import { getI18n } from 'react-i18next';

import Config from '../../../../Config';
import Logger from '../../../../lib/Logger';
import Events from '../../../../lib/EventEmitter';

import CognitoFormsScreen from './containers/CognitoFormsScreenContainer';
import CognitoFormAddScreen from './containers/CognitoFormAddScreenContainer';
import CognitoFormEditScreen from './containers/CognitoFormEditScreenContainer';

const register = () => {
  Logger.log('debug', `cognitoForms.register()`);

  if (Config.getIn(['MODULE_TOGGLES', 'cognitoForms', 'routes'])) {
    Events.dispatch('ADD_MAIN_ROUTES', {
      CognitoFormAddScreen: [
        'PrivateRoute',
        '/cognito-forms/add',
        true,
        CognitoFormAddScreen,
        getI18n().t('cognito_form_route_add'),
      ],
      CognitoFormEditScreen: [
        'PrivateRoute',
        '/cognito-forms/edit/:id([\\w\\-]+)',
        true,
        CognitoFormEditScreen,
        getI18n().t('cognito_form_route_edit'),
      ],
      CognitoFormsScreen: [
        'PrivateRoute',
        '/cognito-forms/:page(\\d+)?',
        true,
        CognitoFormsScreen,
        getI18n().t('cognito_forms_route_list'),
      ],
    });
  }
};

export default register;

Logger.log('silly', `cognitoForms.register() loaded.`);
